import { getAndroidOrIOS } from "../../utils";
import "./style.scss";

const androidLink =
  "https://play.google.com/store/apps/details?id=com.drxasia.app";
const iphoneLink = "https://apps.apple.com/id/app/drx-sportnet/id6451012243";

const RegisterOwnerShip = () => {
  const onClickAppBtn = () => {
    window.location.href =
      getAndroidOrIOS() === "ios" ? iphoneLink : androidLink;
  };

  return (
    <div className="register-ownership-wrapper">
      <div className="section-box">
        <div className="item-center">
          <span className="intro-text">
            Register your Ownership on DRX App!
          </span>
          <span className="description">
            Claim ownership of this product in your account on the DRX Sportnet
            App!
          </span>

          <button onClick={onClickAppBtn} className="open-drx-btn">
            Open DRX App
          </button>
        </div>
      </div>
    </div>
  );
};

export default RegisterOwnerShip;
